import { categoriesData, styleMovie } from '@/data/constants';
import { dataCountry } from '@/data/constants';
export const createSlug = (title: string) => {
  return title
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
};

export const formatDate = (isoString: string) => {
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatCheckValue = (value: string) => {
  switch (value) {
    case 'Vietsub #1':
      return 'vietsub';
    case 'Lồng Tiếng #1':
      return 'thuyetminh';
    case 'thuyetminh':
      return 'Lồng Tiếng #1';
    case 'vietsub':
      return 'Vietsub #1';
    default:
      return 'vietsub';
  }
};

export const getTitleFormSlug = (value: string): string => {
  const data = categoriesData
    .concat(styleMovie)
    .concat(dataCountry)
    .filter((val) => val.slug === value)[0];
  return data.title;
};
